<template>
  <q-page
    ref="seatPage"
    class="page column no-wrap items-stretch justify-between relative-position"
    :class="{ 'fixed-full': $register || (checkoutData.stepTitle === $t('checkout.steps.seats') && checkoutData.showCheckoutFooter) }"
    style="
      margin-left: auto;
      margin-right: auto;
      min-height: unset;
      width: 100%;
    "
    :style="{
      'margin-bottom': $kiosk || $isLandscapeView() || !checkoutData.showCheckoutFooter ? '0px' : '70px',
      'margin-top': topMargin,
      'max-width': $isLandscapeView() ? `${pageMaxWidth}px` : undefined
    }"
  >
    <seats-picker
      v-if="currentSite.consumerConfig.showTicketFirstCheckoutFlow"
      ref="seatsPicker"
      data-test-id="seat-picker"
      :emit-next="emitNext"
      :ticket-order-items="ticketOrderItems"
      @page-max-width="value => pageMaxWidth = value"
      @next="$emit('next')"
    />
    <seats-and-tickets-picker
      v-else
      ref="seatsAndTicketsPicker"
      data-test-id="seat-and-tickets-picker"
      :ticket-order-items="ticketOrderItems"
      @page-max-width="value => pageMaxWidth = value"
      @next="$emit('next')"
    />
  </q-page>
</template>

<script>
import { defineAsyncComponent } from 'vue'

export default {
  name: 'Seats',
  components: {
    SeatsPicker: defineAsyncComponent(() => import('src/modules/checkout/components/SeatsPicker')),
    SeatsAndTicketsPicker: defineAsyncComponent(() => import('src/modules/checkout/components/SeatsAndTicketsPicker'))
  },
  inject: ['order', 'checkoutData'],
  context: ['currentRegisterClient'],
  configuration: ['currentSite'],
  props: {
    emitNext: {
      type: Boolean,
      required: false,
      default: false
    },
    emitActions: {
      type: Boolean,
      required: false,
      default: false
    },
    hideCheckoutControls: {
      type: Boolean,
      default: false,
      required: false
    },
    ticketOrderItems: {
      type: Array,
      default: () => [],
      required: false
    }
  },
  emits: ['next', 'register'],
  data () {
    return {
      pageMaxWidth: 700
    }
  },
  computed: {
    topMargin () {
      if (this.$kiosk) {
        if (this.isTicketPrintingDisabled) {
          return this.$isLandscapeView() ? '130px' : '50px'
        } else {
          return this.$isLandscapeView() ? '80px' : undefined
        }
      } else if (this.$consumer && !this.checkoutData.showCheckoutFooter) {
        return undefined
      } else {
        if (!this.$isLandscapeView() && this.$q.screen.gt.xs) return '0px'
        if (this.$q.screen.gt.xs) return '80px'
        if (window._cordovaNative) return '200px'
        return `${this.checkoutData.headerHeight}px`
      }
    },
    isTicketPrintingDisabled () {
      return this.currentRegisterClient?.registerStation?.registerType?.kioskOptions?.disable_ticket_printing
    }
  },
  trackPage () {
    return {
      showingId: (this.order?.showing && this.order.showing.id) || undefined,
      // Append additional tracking metadata for the checkout flow
      ...this.checkoutData.trackingData
    }
  },
  methods: {
    next () {
      if (this.currentSite.consumerConfig.showTicketFirstCheckoutFlow) {
        this.$refs.seatsPicker.next()
      } else {
        this.$refs.seatsAndTicketsPicker.next()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::deep(.q-dialog.default-background > .q-dialog__inner) {
  background-color: var(--q-background);
}

::deep(.attendance-bar){
  height: 6px;
  transition: all 0.3s ease-in-out;
  margin: -7px 1px 0;
  border-radius: 0 0 3px 3px;
  &:hover{
    height: 10px;
    margin: -11px 1px 0;
  }

  &.compact-button{
    border-radius: 0 0 5px 5px;
    margin: -6px 0px 0;
    &:hover{
      height: 10px;
      margin: -10px 0px 0;
    }
  }
  &.slider-button{
    margin: -9px 1px 0;
    &:hover{
      height: 9px;
      margin: -12px 0px 0;
    }
  }
}
</style>
